import React from "react";

const AddRound = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 6V18M18.25 12H6.25"
        stroke="#FF8500"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default AddRound;
